import React from 'react';

const IPHomepage = () => {
  return (
    <>
      <h2>Inspection Pal</h2>
      <p>Powered by Yoda Safety Services</p>
    </>
  );
};

export default IPHomepage;
